import { Component, HostListener, inject } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
  selector: 'lem-confirm-dialog',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  readonly dialog = inject(ConfirmDialogService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.dialog.state()) this.dialog.cancel();
  }
}
